import graphqlResource, { GraphqlResource } from 'modules/core/graphql-resource';
import { matchesMapper } from '../data-mappers/matches-mapper';

import { MatchDto } from '../interfaces/dtos';
import { unwrapGraphql } from 'shared/errors';
import { ResponseGraphql } from 'shared/types/response-graphql';

/** GraphQL отдаёт `errors` (массив), а не `error` — так было объявлено раньше, и отказ не проверялся. */
type MatchesByDateResponseDto = ResponseGraphql<{
  matchesByDate: MatchDto[];
}>;

class ScheduleRepository {
  constructor(private readonly graphqlResource: GraphqlResource) {}

  async fetchMatchesByDateRange(tournamentId: number, startDate: Date, endDate: Date) {
    const query = `#graphql
      query getMatchesByDateRange($tournamentId: Int!, $dateFrom: String!, $dateTo: String!) {
       matchesByDate(
              input: {
                  tournamentId: $tournamentId
                  limit: 500
                  dateFrom: $dateFrom
                  dateTo: $dateTo
              }
          ) {
              id
              teams {
                  id
                  name
                  emblem {
                      externalUrl
                  }
              }
              date
              sportType
              teamMatches {
                  team {
                      id
                  }
                  score
              }
              round {
                  id
                  name
                  stage {
                      id
                  }
              }
              championship {
                  id
                  name
                  tournament {
                      id
                      address {
                          city
                      }
                  }
                  settings {
                      id
                      name
                      value
                  }
              }
          }
      }
    `;

    const result = await this.graphqlResource.query<MatchesByDateResponseDto>(query, {
      tournamentId,
      dateFrom: startDate.toISOString(),
      dateTo: endDate.toISOString(),
    });

    return matchesMapper(unwrapGraphql(result.data).matchesByDate);
  }
}

const scheduleRepository = new ScheduleRepository(graphqlResource);
export default scheduleRepository;
